import { useCallback } from 'react';
import { useSettings } from '../context/SettingsContext';

export function useDashboardTourStatus() {
  const { settings, updateSettings } = useSettings();
  
  // Get tour status from settings (already preloaded)
  const hasCompletedAnyTour = settings.dashboard_tour_completed || false;
  
  // Mark that user has completed a dashboard tour
  const markDashboardTourCompleted = useCallback(async () => {
    try {
      await updateSettings({
        dashboard_tour_completed: true
      });
      return true;
    } catch (error) {
      console.error('Error marking tour completed:', error);
      return false;
    }
  }, [updateSettings]);
  
  return { 
    hasCompletedAnyTour, 
    markDashboardTourCompleted,
    loading: false // Settings are already loaded via context
  };
}